import { createRoot } from 'react-dom/client';
import App from './app/App';
import './styles/index.css';
import { initSentry, Sentry } from './lib/sentry';
import { initAnalytics } from './lib/analytics';
import { AnalyticsProvider } from './lib/analytics-provider';

initSentry('customer');
initAnalytics('customer');

const FallbackScreen = ({ resetError }: { resetError: () => void }) => (
  <div className="w-full h-screen bg-background flex items-center justify-center p-6">
    <div className="text-center max-w-sm">
      <div className="text-5xl mb-3">🎾</div>
      <h1 className="text-xl font-semibold mb-2">Something went wrong.</h1>
      <p className="text-sm text-muted-foreground mb-4">
        We've logged this crash and are looking into it. Try again in a second.
      </p>
      <button
        onClick={() => { resetError(); location.reload(); }}
        className="h-11 px-5 rounded-xl bg-[#1A6B4F] text-white text-sm"
      >
        Reload
      </button>
    </div>
  </div>
);

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={FallbackScreen} showDialog={false}>
    <AnalyticsProvider>
      <App />
    </AnalyticsProvider>
  </Sentry.ErrorBoundary>,
);
